export default __webpack_public_path__ + "static/media/CLAP_1.a5a4bbee.wav";